import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { StudentsTable } from "./StudentsTable";
import {
  indexRequests,
  indexSessions,
} from "../../api/endpoints/supervisors/sessions";
import SessionModel from "../../api/models/SessionModel";
import { showApiErrorMessages } from "../../helpers";
import { ApiCommonParams } from "../../api/@types/apiTypes";
import Pagination from "../pagination/Pagination";
import PlaceHolder from "../placeHolder.tsx/PlaceHolder";
import { RequestsType } from "../../api/@types/globalTypes";

export default function ReadersRequestsView() {
  const [currentPage, setCurrentPage] = useState(1);

  const { data: requests } = useQuery(
    ["requests", currentPage],
    () => {
      let apiParams: ApiCommonParams = {
        filters: { sender_type: "Student", order_by: "-created_at" },
        pagination: { pageSize: 10, pageNumber: currentPage },
      };
      return indexRequests(apiParams);
    },
    {
      keepPreviousData: true,
      select: (response) => {
        let fetchedStudents: RequestsType[] = [];
        if (response.isSuccess) {
          fetchedStudents = response.data;
        } else {
          showApiErrorMessages(response);
        }
        const paginationInfo = response.pagination;
        return { data: fetchedStudents, paginationInfo };
      },
    }
  );

  return (
    <div className="w-full  mt-2 md:mt-0   min-h-screen  flex flex-col justify-between">
      <div
        className={`flex flex-col min-w-full w-fit ${
          !!requests?.data && requests.data.length > 0 && " ring-gray-300"
        }`}
      >
        {!!requests?.data && requests.data.length > 0 ? (
          <>
            <StudentsTable requests={requests.data} />
            <div className="sticky bottom-0 ">
              <Pagination
                hasNext={!!requests.paginationInfo?.hasNext}
                hasPrev={!!requests.paginationInfo?.hasPrev}
                goToPage={(page: number) => setCurrentPage(page)}
                currentPage={requests.paginationInfo?.currentPageNumber!}
                numberOfPages={requests.paginationInfo?.pagesCount!}
              />
            </div>
          </>
        ) : (
          <div className="w-full h-full flex justify-center items-center">
            <PlaceHolder title="noRequests" />
          </div>
        )}
      </div>
    </div>
  );
}
